<template>
  <div class="user-message">
    <!-- 有员工身份 && 发工资倒计时开启 && salaryDay >= 0 -->
    <span v-if="hasEmployeeAccount && appSetting.salaryDay==1 && salaryDay>0" class="salary-day">{{$xinI18n('{#1} 天后发薪','home-XXXXtianhoufaxin',[salaryDay])}}</span>
    <span v-if="hasEmployeeAccount && appSetting.salaryDay==1 && salaryDay==0" class="salary-day">{{$xinI18n('今日发薪','home-jinrifaxin')}}</span>
    <!-- 跳转：有管理员身份 有员工身份 && 档案权限 -->
    <div class="employee-avatar" :class="{'c_pointer':hasAdminAccount && hasEmployeeAccount && permission.verify('portrait')}" @click="handleToPortrait(employeeBasicInfo.employeeId)" >
      <XinAvatar :width="64" :xin-name="accName" :photo="employeeBasicInfo && employeeBasicInfo.employeePic" />
    </div>

    <div class="content m_t16">
      <el-tooltip effect="light" placement="top" :disabled="userInfoTipDisabled">
        <div slot="content">
          {{accName}}
          <template v-if="hasEmployeeAccount">
            <br v-if="employeeBasicInfo.departmentName" />
            {{employeeBasicInfo.departmentName}}
            <br v-if="employeeBasicInfo.jobName" />
            {{employeeBasicInfo.jobName}}
          </template>
        </div>
        <p class="info">
          <span class="name">{{strSlice(accName,hasEmployeeAccount?6:22)}}</span>
          <span class="dep" v-if="hasEmployeeAccount && (employeeBasicInfo.departmentName||employeeBasicInfo.jobName)">（{{strSlice(employeeBasicInfo.departmentName,8)}}{{employeeBasicInfo.departmentName&&employeeBasicInfo.jobName?'·':''}}{{strSlice(employeeBasicInfo.jobName,6)}}）</span>
        </p>
      </el-tooltip>

      <!-- 有员工身份 && 员工假期余额开启 -->
      <p v-if="showVacationDay" class="vacation">
        <span v-if="vacationDay.surplusSwitch && vacationDay.surplusAnnualLeaveDays">{{$xinI18n('年假','ApplyV2-holidayTypeNameEnum-nianjia')}} <i>{{vacationDay.surplusAnnualLeaveDays}}</i> {{$xinI18n('天','Common-tians')}}</span>
        <span v-if="vacationDay.availableOffSwitch && vacationDay.availableOffDays">{{$xinI18n('调休','shine-tiaoxiu')}} <i>{{vacationDay.availableOffDays}} </i> {{$xinI18n('天','Common-tians')}}</span>
      </p>
    </div>
    <div v-if="hasEmployeeAccount" class="detail-btn">
      <div class="tab-btn c_pointer sk--hover-text" @click="handleToEmployeeDetail('personalInfo')">
        <xin-icon xin-type="file-user-line" />
        {{$xinI18n('个人信息','Employee-MyTeam-gerenxinxi')}}
      </div>
      <div class="tab-btn c_pointer sk--hover-text" @click="handleToEmployeeDetail('jobInfo')">
        <xin-icon xin-type="briefcase-line" />
        {{$xinI18n('岗位信息','Home-IndexHeader-gangweixinxi')}}
      </div>
      <!-- 是否展示看开关 -->
      <div v-if="appSetting.rewardPunish==1" class="tab-btn c_pointer sk--hover-text" @click="handleToEmployeeDetail('rewardInfo')">
        <xin-icon xin-type="medal-line" />
        {{$xinI18n('奖惩信息','Home-IndexHeader-jiangchengxinxi')}}
      </div>
      <!-- 是否展示看开关 -->
      <div v-if="appSetting.esoSwitch==1" class="tab-btn c_pointer sk--hover-text" @click="handleToEmployeeDetail('stockInfo')">
        <xin-icon xin-type="funds-line" />
        {{$xinI18n('期权信息','Common-qiquanxinxi')}}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import {namespace} from 'vuex-class';
  import { XinAvatar } from "@xin/xin-ui"
  import { HomeApi } from '@/module/home/service/home-api.service';

  const moduleInfra = namespace('moduleInfra');

  @Component({
    components:{
      XinAvatar
    }
  })
  export default class UserMessage extends Vue {
    //身份标识
    @moduleInfra.Getter('getHasAdminAccount') public hasAdminAccount!: number;
    @moduleInfra.Getter('getHasEmployeeAccount') public hasEmployeeAccount!: number;
    @moduleInfra.Getter('getAccName') public accName!: string;
    @moduleInfra.Getter('getEmployeeBasicInfo') public employeeBasicInfo!: any;

    @Prop({default:()=>({})})
    appSetting!:any
    
    salaryDay = -1
    vacationDay = {
      surplusSwitch:0,
      availableOffSwitch:0,
      surplusAnnualLeaveDays:0,
      availableOffDays:0
    }

    get userInfoTipDisabled(){
      if(this.hasAdminAccount && !this.hasEmployeeAccount){
        return this.accName.length <= 22
      }else{
        return (this.accName||'').length <=6 && this.employeeBasicInfo && (this.employeeBasicInfo.departmentName||'').length <= 8 && (this.employeeBasicInfo.jobName||'').length <= 6
      }
    }

    get showVacationDay(){
      const showSurplus = this.vacationDay.surplusSwitch && this.vacationDay.surplusAnnualLeaveDays
      const showAvailableOff = this.vacationDay.availableOffSwitch&&this.vacationDay.availableOffDays
      return this.hasEmployeeAccount && this.appSetting.holidayBalance==1 && (showSurplus || showAvailableOff)
    }

    created(){
      this.getSalaryDay()
      this.getAvailableSurplusDay()
    }

    //获取发薪日
    getSalaryDay(){
      if(!this.hasEmployeeAccount || this.appSetting.salaryDay==0){
        return
      }
      HomeApi.getSalaryDay().then((data:any)=>{
        if(typeof data == 'number'){
          this.salaryDay = data
        }
      })
    }

    //获取年假调休
    getAvailableSurplusDay(){
      if(!this.hasEmployeeAccount || this.appSetting.holidayBalance==0){
        return
      }
      HomeApi.getAvailableSurplusDay().then((data:any)=>{
        if(data){
          this.vacationDay = data
        }
      })
    }

    strSlice(str:string,num:number){
      if((str||'').length > num){
        return str.slice(0,num)+'...'
      }else{
        return str
      }
    }

    handleToEmployeeDetail(tab:string){
      this.XrxsTracker.$track('a_homeClickUserMessage','',tab)
      window.location.href="/staff/information/index?activeName="+tab
    }

    handleToPortrait(employeeId:string){
      if(this.hasAdminAccount && this.hasEmployeeAccount && this.permission.verify('portrait')){
        this.XrxsTracker.$track('a_homeClickUserMessage','','portrait')
        window.location.href = `/portrait/detail?employeeId=${employeeId}`
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
